import { RowingIcon } from './RowingIcon';

/**
 * author: Google
 * id 72F11BA0-1557-4500-8235-2E3F2346FE69
 * name rowing
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/rowing.svg
 * tags
 * - Sport 
 * - Transportation + Water 
 * - People / Family 
 */
export const HumanRowingIcon = RowingIcon;
export default HumanRowingIcon